import React from "react";

export default function Error({ msg }) {
  return <div>{msg}</div>;
}
